<template>
  <b-col sm="12" lg="8">
    <div class="animated fadeIn">
      <b-card>
        <Toasts></Toasts>
        <div v-if="loading" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h4>User Info</h4>
          <span class="title-details">
            <b>Full Name:</b>
            {{ userInfo.name }}
          </span>
          <span class="title-details">
            <b>Email:</b>
            {{ userInfo.email }}
          </span>
          <span class="title-details">
            <b>Company:</b>
            {{ userInfo.company }}
          </span>
          <span class="title-details">
            <b>Title:</b>
            {{ userInfo.title }}
          </span>
          <hr />
          <b-row>
            <b-col sm="12" lg="12">
              <h4>Change Password</h4>
            </b-col>
            <b-col sm="12" lg="4">
              <input
                type="password"
                ref="newPw"
                class="form-control"
                placeholder="Enter new password..."
              />
            </b-col>
            <b-col sm="12" lg="4">
              <input
                type="password"
                ref="newPwC"
                class="form-control"
                placeholder="Confirm new password..."
              />
            </b-col>
            <b-col sm="12" lg="4">
              <b-button variant="outline-primary" @click="changePassword()"
                >Change Password</b-button
              >
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import router from "../router";

export default {
  name: "ProfilePicture",
  components: {
    cSwitch,
    router
  },
  props: ["userData", "userId"],
  data() {
    return {
      loading: true,
      // dataRdy: 0,
      userInfo: this.userData
    };
  },

  methods: {
    changePassword() {
      let newPassword = this.$refs.newPw.value;
      let newConfirm = this.$refs.newPwC.value;

      if (newPassword === newConfirm && newPassword != "") {
        this.$refs.newPwC.style.border = "";
        let formData = new FormData();
        formData.append("userId", this.userId);
        formData.append("new_pass", newPassword);
        formData.append("confirm_pass", newConfirm);
        this.$http
          .post("api/atx/profile/changePassword.php", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(
            () => {
              localStorage.clear();
              router.push("/pages/login/");
              this.loading = false;
            },
            err => {
              console.log(err);
            }
          );
      } else {
        this.$refs.newPwC.style.border = "1px solid red";
      }
    }
    // valueChange(param) {
    //   if (this.dataRdy == 6) {
    //     let checked;
    //     if (param.checked == true) {
    //       param.checked = false;
    //       console.log(param);
    //       checked = 0;
    //     } else {
    //       param.checked = true;
    //       console.log(param);
    //       checked = 1;
    //     }
    //     let formData = new FormData();
    //     formData.append("userId", this.userId);
    //     formData.append("group", param.name.replace(/\s+/g, "").toLowerCase());
    //     formData.append("val", checked);
    //     // this.$http
    //     //     .post(
    //     //       "api/profile/updateVisiblePG.php",
    //     //       formData,
    //     //     )
    //     //     .then(
    //     //       res => {
    //     //         console.log(res.data);
    //     //         this.$toast.success("Changes Applied!");
    //     //       },
    //     //       err => {
    //     //         console.log(err);
    //     //       }
    //     //     );
    //   } else {
    //     this.dataRdy++;
    //     console.log(this.dataRdy);
    //   }
    // }
  },
  mounted() {
    this.loading = false;
  }
};
</script>

<style scoped>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.card-body {
  min-height: 480px !important;
}
</style>
